/**
 * Leviathan Web - Geometric Panel Component
 * Quasar Prime LLC
 * Reusable geometric panel with corner brackets
 */

import { ReactNode } from 'react';

interface GeometricPanelProps {
  children: ReactNode;
  cornerColor?: 'amber' | 'steel';
  className?: string;
}

/**
 * Geometric panel with corner brackets
 */
export const GeometricPanel = ({ children, cornerColor = 'amber', className = '' }: GeometricPanelProps) => {
  const borderColor = cornerColor === 'amber' ? 'border-amber' : 'border-steel';

  return (
    <div className={`relative stat-card ${className}`}>
      <div className={`absolute top-0 left-0 w-4 h-4 border-l-2 border-t-2 ${borderColor}`} />
      <div className={`absolute top-0 right-0 w-4 h-4 border-r-2 border-t-2 ${borderColor}`} />
      <div className={`absolute bottom-0 left-0 w-4 h-4 border-l-2 border-b-2 ${borderColor}`} />
      <div className={`absolute bottom-0 right-0 w-4 h-4 border-r-2 border-b-2 ${borderColor}`} />

      <div className="bg-panel-dark border border-panel-border p-6 clip-path-octagon relative">
        {children}
      </div>
    </div>
  );
};
